/* eslint max-len: 0 */
/* eslint consistent-return: 0 */

/**
 * Url module for configuring the route provider
 * Stores all app routes
 */
angular.module('urls')
    .config(($stateProvider, $urlRouterProvider) => {

        const Resolvers = angular.module('resolvers');
        const Modals = angular.module('modals');

        if (window.location.href.indexOf('/dashboard/renewal') > -1) {

            window.activeNavSection = 'renewal';

        }

        const rule = ($injector, $location) => {

            const path = $location.path();

            if (path.indexOf('sld/') > -1) {

                $location.replace().path(path.replace(/\/(sld)\/(.*)/gi, ''));

            }

            if (path.slice(-1) === '/') {

                $location.replace().path(path.slice(0, -1));

            }

            /*  Redirect Reset Password URLS that are still coming with JWT tokens (old links)
                This condition should be removed after all the clients will
                send the new SSO route for reset password flow */
            if (path.indexOf('/auth/reset/jwt/') > -1) {

                const urlRoute = path.split('/') || [];
                const jwtIndex = urlRoute.findIndex(route => route === 'jwt') + 1;

                window.location.href = `/${CWCONFIG.language}/auth/reset?access_token=${urlRoute[jwtIndex]}&client_id=dashboard`;

            }

            // Fallback for old download kit page
            if (path.indexOf('/downloadKit/service/') > -1) {

                const getDownloadUrl = path.substr(path.lastIndexOf('/') + 1) || '';
                const decodeDownloadUrl = atob(getDownloadUrl) || '';
                const appId = decodeDownloadUrl.split('_')[2];
                const detectOsByFileExtension =
                      decodeDownloadUrl.substr(decodeDownloadUrl.lastIndexOf('.') + 1) || '';

                let os = 'windows';

                if (detectOsByFileExtension === 'dmg') {

                    os = 'osx';

                }

                window.location.href = `/${CWCONFIG.language}/auth/login?client_id=dashboard&redirect_uri=/dashboard/devices/new/ltb/deploy?appId=${appId}%26os=${os}`;

            }

        };

        const subscriptionsRule = ($injector, $location) => {

            const path = $location.path();
            if (path.indexOf('subscriptions') > -1 && path.indexOf('tabs') === -1) {

                // fix missing tabs
                return path.replace('/subscriptions', '/subscriptions/tabs/plans');

            }

        };

        const routeError = ($injector, $location) => {

            $location.replace().path('/');

        };

        rule.$inject = ['$injector', '$location'];

        // rules for Dashboard
        $urlRouterProvider
            .when('/', '/dashboard/home')
            .when('/apple-login', '/auth/login')
            .when('/dashboard', '/dashboard/home')
            .when('/dashboard/apps/:resourceId/devices/:deviceId', '/dashboard/home')

            // redirect old routes
            .when('/registration/:notFound*options', '/auth/register')
            .when('/auth/login/myat/:ahash*options', '/auth/login/t/:ahash*options')
            .when('/dashboard/subscriptions', '/dashboard/subscriptions/tabs/plans')
            .when('/dashboard/subscriptions/', '/dashboard/subscriptions/tabs/plans')
            .when('/dashboard/support', '/dashboard/support/tabs/support')
            .when('/dashboard/support/', '/dashboard/support/tabs/support')

            // CMA Redirect
            .when('/dashboard/renewal', '/dashboard/subscriptions/tabs/plans')
            .when('/dashboard/renewal/tabs/plans', '/dashboard/subscriptions/tabs/plans')

            // TODO these rules must be deleted when the URL will contain only JWT
            .when('/auth/login/adt/:token*options', '/auth/login/jwt/:token*options')
            .when('/auth/login/t/:token*options', '/auth/login/jwt/:token*options')
            .otherwise(routeError)
            // Allow all routes to end with a trailing `/` and redirect to the normal route
            .rule(rule)
            // Fill all old subscriptions routes
            .rule(subscriptionsRule);

        $stateProvider

            // Root state
            .state('root', {
                abstract: true,
                views: {
                    root: {
                        controller: 'Root',
                    },
                },
                resolve: {
                    translation: Resolvers.Translation,
                    tab: ['RootResolver', '$q', (RootResolver, $q) => {

                        const deferred = $q.defer();

                        // waiting for RootResolver to be resolved
                        RootResolver.then(() => {

                            deferred.resolve();

                        });

                        return deferred.promise;

                    }],
                },
            })

            // DEBUG ROUTE
            .state('debug', {
                views: {
                    'debug.abstract': {
                        template: '',
                        controller: 'forceDebug',
                    },
                },
                url: '/debug',
            })

            .state('root.main', {
                url: '/',
            })

            // AUTH
            .state('root.auth', {
                abstract: true,
                views: {
                    'landing.auth': {
                        template: require('./controllers/auth/landing-page.html'),
                    },
                    'main.auth': {
                        template: require('./common/controllers/auth/baseAuth.html'),
                        controller: 'BaseAuth',
                    },
                },
                url: '/auth',
                onEnter: (() => {

                    const onEnter = ($document) => {

                        angular.element($document[0].body).addClass('auth');

                    };
                    onEnter.$inject = ['$document'];

                    return onEnter;

                })(),
                onExit: (() => {

                    const onExit = ($document) => {

                        angular.element($document[0].body).removeClass('auth');

                    };
                    onExit.$inject = ['$document'];

                    return onExit;

                })(),
            })
            .state('root.auth.set-password', {
                url: '/set-password/*options',
                views: {
                    'main.auth@root': {
                        template: require('./controllers/auth/set-password/set-password.html'),
                        controller: 'SetPassword',
                        controllerAs: 'oauthCtrl',
                    },
                },
            })
            .state('root.auth.login', {
                url: '/login',
                template: require('./controllers/auth/login/login.html'),
                controller: 'Login',
                controllerAs: 'oauthCtrl',
            })
            // LTB Login
            .state('root.auth.login.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })
            .state('root.auth.register', {
                url: '/register',
                template: require('./controllers/auth/register/register.html'),
                controller: 'Register',
                controllerAs: 'oauthCtrl',
            })
            // LTB Register
            .state('root.auth.register.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })
            .state('root.auth.forgot', {
                url: '/forgot',
                template: require('./controllers/auth/forgot/forgot.html'),
                controller: 'Forgot',
                controllerAs: 'oauthCtrl',
            })
            // LTB Forgot
            .state('root.auth.forgot.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })
            .state('root.auth.reset', {
                url: '/reset',
                template: require('./controllers/auth/reset/reset.html'),
                controller: 'Reset',
                controllerAs: 'oauthCtrl',
            })
            // LTB Reset
            .state('root.auth.reset.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })
            .state('root.auth.confirm', {
                url: '/confirm',
                template: require('./controllers/auth/confirm/confirm.html'),
                controller: 'Confirm',
                controllerAs: 'oauthCtrl',
            })
            // LTB Confirm
            .state('root.auth.confirm.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })
            .state('root.auth.jwt', {
                url: '/login/jwt/:token*options',
                template: '',
                controller: 'LoginJWT',
            })
            .state('root.auth.ahash', {
                url: '/login/myat/:ahash*options',
                template: '',
                controller: 'LoginAHash',
            })
            .state('root.auth.tfa', {
                url: '/tfa',
                template: require('./controllers/auth/tfa/tfa.html'),
                controller: 'Tfa',
                controllerAs: 'oauthCtrl',
            })
            // LTB TFA
            .state('root.auth.tfa.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })
            // SSO Logout
            .state('root.auth.logout', {
                url: '/logout',
                resolve: {
                    auth: ['Auth', (Auth) => {

                        Auth.logOut();

                    }],
                },
            })

            // BASE STATE
            .state('root.dashboard', {
                abstract: true,
                views: {
                    'main.dashboard': {
                        template: require('./controllers/dashboard/dashboard.html'),
                        controller: 'Dashboard',
                        controllerAs: 'dashboardCtrl',
                    },
                    'dashboard.navigation@root.dashboard': {
                        template: require('./controllers/dashboard/navigation/navigation.html'),
                        controller: 'DashboardNavigation',
                    },
                    'dashboard.body@root.dashboard': {
                        template: require('./controllers/dashboard/body/body.html'),
                        controller: 'DashboardBody',
                    },
                },
                url: '/dashboard',
                resolve: {
                    tab: ['RootResolver', 'DashboardResolver', '$q', '$rootScope',
                        (RootResolver, DashboardResolver, $q, $rootScope) => {

                            const deferred = $q.defer();

                            // wait for RootResolver to be done to get dashboard resources
                            RootResolver.then(() => {

                                // get dashboard resources and hide loading state
                                DashboardResolver.getDashboardResourcesPromise().then(() => {

                                    deferred.resolve();
                                    $rootScope.State.loading = false;

                                });

                            });

                            return deferred.promise;

                        }],
                },
            })

            // MY ACCOUNT TABS
            .state('root.dashboard.my-account', {
                url: '/my-account/tabs/:tab',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/my-account/my-account.html'),
                        controller: 'MyAccount',
                    },
                },
            })

            // LTB MY ACCOUNT
            .state('root.dashboard.my-account.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // NEWS
            .state('root.dashboard.news', {
                url: '/news/tabs/:tab?page',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/news/news.html'),
                        controller: 'News',
                        controllerAs: 'NewsCtrl',
                    },
                },
            })

            // NEWS SINGLE ARTICLE VIEW
            .state('root.dashboard.article', {
                url: '/news/tabs/:tab/article/:id?page',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/news/article.html'),
                        controller: 'Article',
                        controllerAs: 'ArticleCtrl',
                    },
                },
            })

            // HOME
            .state('root.dashboard.home', {
                url: '/home',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/homepage/homepage.html'),
                        controller: 'Homepage',
                        controllerAs: 'homepageCtrl',
                    },
                },
            })

            // LTB HOME
            .state('root.dashboard.home.ltb', {
                url: '/:resourceId/ltb/:ltb?trial',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB NEWS LIST
            .state('root.dashboard.news.ltb', {
                url: '/:resourceId/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB NEWS ARTICLE
            .state('root.dashboard.article.ltb', {
                url: '/:resourceId/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB HOME DEPLOY
            // .state('root.dashboard.home.ltb.deploy', {
            //     parent: 'root.dashboard.home.ltb',
            //     url: '?deviceId&os&autoInstall',
            // })

            .state('root.dashboard.home.ltb.deploy', {
                parent: 'root.dashboard.home.ltb',
                url: '?appId&os&deviceCategory',
            })

            // LTB HOME BANNER PAYMENT
            .state('root.dashboard.home.ltb.banner', {
                parent: 'root.dashboard.home.ltb',
                url: '?promotion&subsource&variant&runtime',
            })

            // LTB HOME RENEW
            .state('root.dashboard.home.ltb.renew', {
                parent: 'root.dashboard.home.ltb',
                url: '?subsource?licenseId',
            })

            // MY DEVICES
            .state('root.dashboard.devices', {
                url: '/devices?deploy',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/devices/devices.html'),
                        controller: 'Devices',
                    },
                },
            })

            // LTB MY DEVICES
            .state('root.dashboard.devices.ltb', {
                url: '/:resourceId/ltb/:ltb?trial',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB MY DEVICES DEPLOY
            .state('root.dashboard.devices.ltb.deploy', {
                parent: 'root.dashboard.devices.ltb',
                url: '?appId&os&deviceCategory',
            })

            // LTB MY DEVICES BANNER PAYMENT
            .state('root.dashboard.devices.ltb.banner', {
                parent: 'root.dashboard.devices.ltb',
                url: '?promotion&subsource&variant&runtime',
            })

            // DEVICE DETAILS
            // DEVICE DETAILS TAB
            .state('root.dashboard.device-details', {
                url: '/devices/:resourceId/tabs/:tab',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/device-details/device-details.html'),
                        controller: 'DeviceDetails',
                    },
                },
            })

            // LTB DEVICE DETAILS TAB
            .state('root.dashboard.device-details.ltb', {
                parent: 'root.dashboard.device-details',
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB DEVICE DETAILS TAB DEPLOY
            .state('root.dashboard.device-details.ltb.deploy', {
                parent: 'root.dashboard.device-details.ltb',
                url: '?appId?autoInstall',
            })

            // LTB DEVICE DETAILS TAB ACTIVATE
            .state('root.dashboard.device-details.ltb.activate', {
                parent: 'root.dashboard.device-details.ltb',
                url: '?appId&bundle&installed',
            })

            // LTB DEVICE DETAILS BUY
            .state('root.dashboard.device-details.ltb.buy', {
                parent: 'root.dashboard.device-details.ltb',
                url: '?appId&promotion&subsource',
            })

            // APP DETAILS
            .state('root.dashboard.device-details.app-details', {
                parent: 'root.dashboard.device-details',
                url: '/apps/:appId',
            })

            // SUBSCRIPTIONS
            .state('root.dashboard.subscriptions', {
                url: '/subscriptions/tabs/:tab',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/subscriptions/subscriptions.html'),
                        controller: 'Subscriptions',
                        controllerAs: 'subscriptionsCtrl',
                    },
                },
            })

            // LTB MY SUBSCRIPTIONS
            .state('root.dashboard.subscriptions.ltb', {
                url: '/:resourceId/ltb/:ltb?trial',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB MY SUBSCRIPTIONS DEPLOY
            .state('root.dashboard.subscriptions.ltb.deploy', {
                parent: 'root.dashboard.subscriptions.ltb',
                url: '?deviceId&appId&os&autoInstall',
            })

            // LTB MY SUBSCRIPTIONS RENEW
            .state('root.dashboard.subscriptions.ltb.renew', {
                parent: 'root.dashboard.subscriptions.ltb',
                url: '?subsource?licenseId',
            })

            // LTB MY SUBSCRIPTIONS BANNER PAYMENT
            .state('root.dashboard.subscriptions.ltb.banner', {
                parent: 'root.dashboard.subscriptions.ltb',
                url: '?promotion&subsource&variant&runtime',
            })

            // MY PRODUCTS
            .state('root.dashboard.products', {
                url: '/products',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/products/products.html'),
                        controller: 'Products',
                    },
                },
            })

            // LTB MY PRODUCTS
            .state('root.dashboard.products.ltb', {
                url: '/:resourceId/ltb/:ltb?trial',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB MY PRODUCTS DEPLOY
            .state('root.dashboard.products.ltb.deploy', {
                parent: 'root.dashboard.products.ltb',
                url: '?deviceId&os&autoInstall&deployType',
            })

            // LTB MY PRODUCTS
            .state('root.dashboard.products.ltb.activate', {
                parent: 'root.dashboard.products.ltb',
                url: '?appId&os',
            })

            // LTB MY PRODUCTS BANNER PAYMENT
            .state('root.dashboard.products.ltb.banner', {
                parent: 'root.dashboard.products.ltb',
                url: '?promotion&subsource&variant&runtime',
            })

            // LTB MY PRODUCTS BUY
            .state('root.dashboard.products.ltb.buy', {
                parent: 'root.dashboard.products.ltb',
                url: '?promotion&subsource',
            })

            // STORE
            .state('root.dashboard.store', {
                url: '/store',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/store/store.html'),
                        controller: 'Store',
                    },
                },
            })

            // LTB STORE
            .state('root.dashboard.store.ltb', {
                url: '/:resourceId/ltb/:ltb?trial',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB STORE BUY
            .state('root.dashboard.store.ltb.buy', {
                parent: 'root.dashboard.store.ltb',
                url: '?promotion&runtime&subsource&variant',
            })

            // SUPPORT
            .state('root.dashboard.support', {
                url: '/support/tabs/:tab',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/support/support.html'),
                        controller: 'Support',
                        controllerAs: 'supportCtrl',
                    },
                },
            })

            // CRYPTO
            .state('root.dashboard.crypto', {
                url: '/crypto/tabs/:tab',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/crypto/crypto.html'),
                        controller: 'Crypto',
                        controllerAs: 'cryptoCtrl',
                    },
                },
            })

            // LTB CRYPTO
            .state('root.dashboard.crypto.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // DWM
            .state('root.dashboard.dwm', {
                url: '/identity-assistant/tabs/:tab',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/dwm/dwm.html'),
                        controller: 'Dwm',
                        controllerAs: 'dwmCtrl',
                    },
                },
            })

            // LTB DWM
            .state('root.dashboard.dwm.ltb', {
                url: '/:resourceId/ltb/:ltb?trial',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // LTB DWM BUY
            .state('root.dashboard.dwm.ltb.buy', {
                parent: 'root.dashboard.dwm.ltb',
                url: '?promotion&runtime&subsource&variant&test&button',
            })

            // LTB SUPPORT
            .state('root.dashboard.support.ltb', {
                url: '/ltb/:ltb',
                onEnter: Modals.openModal,
                onExit: Modals.closeModal,
            })

            // GDPR Report Print Page
            .state('root.dashboard.print-gdpr-report', {
                url: '/print-gdpr-report',
                views: {
                    'dashboard.body.content': {
                        template: require('./controllers/dashboard/body/content/print-gdpr-report/print-gdpr-report.html'),
                        controller: 'PrintGDPRReport',
                        controllerAs: 'printGDPRReportCtrl',
                    },
                },
            })

            // not allowed page
            .state('notAllowed', {
                url: '/not-allowed',
                views: {
                    'main.abstract': {
                        template: require('./controllers/landing-pages/not-allowed/not-allowed.html'),
                        controller: 'NotAllowed',
                        controllerAs: 'notAllowedCtrl',
                    },
                },
            })

            // US Compliance failed
            .state('complianceFailed', {
                url: '/compliance-failed',
                views: {
                    'main.abstract': {
                        template: require('./controllers/dashboard/body/content/us-compliance-failed/us-compliance-failed.html'),
                        controller: 'UsComplianceFailed',
                        controllerAs: 'UsComplianceFailedCtrl',
                    },
                },
            });

    });



// WEBPACK FOOTER //
// ./scripts/urls.js